// src/components/SharePointLink.js
import React, { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest, sharepointSiteUrl } from '../authConfig';

function SharePointLink() {
  const { instance, accounts } = useMsal();
  const [isLoading, setIsLoading] = useState(false);
  const [shouldOpenSharePoint, setShouldOpenSharePoint] = useState(false);
  
  // Check if we should open SharePoint after successful login
  useEffect(() => {
    if (shouldOpenSharePoint && accounts.length > 0) {
      // User just logged in and we need to open SharePoint
      window.open(sharepointSiteUrl, '_blank', 'noopener,noreferrer');
      setShouldOpenSharePoint(false);
      setIsLoading(false);
    }
  }, [accounts.length, shouldOpenSharePoint]);
  
  const handleSharePointClick = async (event) => {
    event.preventDefault();
    
    if (isLoading) {
      return; // Prevent multiple clicks
    }
    
    if (accounts.length > 0) {
      // User is already signed in, open SharePoint directly
      window.open(sharepointSiteUrl, '_blank', 'noopener,noreferrer');
    } else {
      // User needs to sign in first
      setIsLoading(true);
      setShouldOpenSharePoint(true);
      
      try {
        // Redirect to login with the updated loginRequest
        await instance.loginRedirect(loginRequest);
      } catch (error) {
        console.error('Login error:', error);
        setIsLoading(false);
        setShouldOpenSharePoint(false);
      }
    }
  };

  return (
    <a 
      href="#"
      onClick={handleSharePointClick} 
      className="link-block"
      style={{
        opacity: isLoading ? 0.6 : 1,
        cursor: isLoading ? 'wait' : 'pointer'
      }}
    >
      {isLoading ? 'Signing in...' : 'Show Uploads and Shared Files'}
    </a>
  );
}

export default SharePointLink;